import {NgClass}                from '@angular/common';
import {Component, input}       from '@angular/core';
import {FoodAnalysisRatingType} from '@djsharkk/logr-types';

@Component({
			   selector   : 'app-ui-food-rating',
			   imports    : [
				   NgClass
			   ],
			   templateUrl: './ui-food-rating.component.html',
			   styleUrl   : './ui-food-rating.component.css'
		   })
export class UiFoodRatingComponent {

	rating = input.required<FoodAnalysisRatingType>();
}
